import React from "react";
import Flagship from "../../core/flagship";
import { Loader, Segment } from "semantic-ui-react";
import Script from "react-load-script";
import { connect } from "react-redux";

/*global powerbi*/

class PowerBI extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true
    };

    this.handleScriptError = this.handleScriptError.bind(this);
  }

  componentDidMount() {
    setTimeout(Flagship.closeSidebarNav, 500);
    document.title = "Flagship / Ship's Log";
  }

  handleScriptError() {
    Flagship.error("Couldn't load Power BI script. ", 0, 0);
  }

  handleScriptLoad() {
    let self = this;
    Flagship.get(
      "power_bi_data",
      {},
      function(response) {
        if (response.data.success === true) {
          let models = window["powerbi-client"].models;
          let embedConfiguration = {
            type: "report",
            id: "d4aee7f0-6965-46ae-a79e-04d88267f858", // the report ID
            embedUrl: response.data.embedUrl,
            accessToken: response.data.token,
            tokenType: models.TokenType.Aad,
            viewMode: models.ViewMode.View,
            settings: {
              filterPaneEnabled: false
            }
          };

          powerbi.embed(
            document.getElementById("fs-power-bi-embed-here"),
            embedConfiguration
          );

          self.setState({
            loading: false
          });
        } else {
          Flagship.error("Failed to retrieve Power BI data.", 0, 0);
        }
      },
      function(err) {
        Flagship.error("Failed to retrieve Power BI: " + err, 0, 0);
      }
    );
  }

  render() {
    return this.props.userRole === "admin" ||
      this.props.userRole === "dbs" ||
      this.props.userRole === "proposal_strategist" ? (
      <Segment style={{ height: "100%", width: "100%" }}>
        {this.state.loading ? (
          <div>
            <Loader className="flagship-loader" active inline="centered" />
          </div>
        ) : null}
        <div
          id="fs-power-bi-embed-here"
          style={{ height: "100%", width: "100%" }}
        ></div>
        <Script
          url={Flagship.config.apiBase + "powerbi.js"}
          onError={this.handleScriptError.bind(this)}
          onLoad={this.handleScriptLoad.bind(this)}
        />
      </Segment>
    ) : (
      <Segment style={{ height: "100%", width: "100%" }}>
        Sorry, you don't have permission to see this.
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    firstName: state.main.userFirstName,
    userRole: state.main.userRole,
    userId: state.main.userId,
    timerRunning: state.time.timerRunning,
    timeRecorded: state.time.timeRecorded,
    timeRecordedFormatted: state.time.timeRecordedFormatted,
    timerClient: state.time.timerClient
  };
}

export default connect(mapStateToProps, null)(PowerBI);



// WEBPACK FOOTER //
// ./src/components/views/PowerBI.js